export default __webpack_public_path__ + "static/media/history_1970_02.95934216.png";